import React from "react";
import { FaWater, FaCalendarAlt, FaUser, FaUsers } from "react-icons/fa";
import { motion } from "framer-motion";
import dayjs from "dayjs";

const BaptismView = ({ currentRecord }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="overflow-hidden mx-auto max-w-4xl bg-white rounded-lg shadow-2xl"
    >
      <div className="p-6 text-center bg-gradient-to-r from-blue-600 to-indigo-700">
        <h2 className="inline-flex items-center text-3xl font-bold text-white">
          <FaWater className="mr-3 text-4xl" />
          Baptism Record
        </h2>
      </div>
      <InfoTable jsonData={currentRecord} />
    </motion.div>
  );
};

export default BaptismView;

const InfoTable = ({ jsonData }) => {
  const keysToShow = Object.keys(jsonData).filter(
    (key) =>
      ![
        "__v",
        "id",
        "createdAt",
        "church_id",
        "createdBy",
        "updatedAt",
        "_id",
      ].includes(key)
  );

  const formatDate = (dateString) => {
    return dayjs(dateString).utc().format("MM/DD/YYYY");
  };

  const getIcon = (key) => {
    if (key.includes("date")) return FaCalendarAlt;
    if (key.includes("name")) return FaUser;
    if (key.includes("parents")) return FaUsers;
    return null;
  };

  return (
    <div className="p-6">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {keysToShow.map((key, index) => {
          const isDateField = key.includes("date");
          const value = jsonData[key];
          const displayValue =
            isDateField && typeof value === "string"
              ? formatDate(value)
              : typeof value === "object" && value !== null
              ? value.label
              : value;

          const Icon = getIcon(key);

          return (
            <motion.div
              key={key}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              className="p-5 bg-white rounded-lg shadow-md transition-all duration-300 hover:shadow-lg hover:bg-gray-50"
            >
              <div className="flex items-center mb-3">
                {Icon && <Icon className="mr-3 text-2xl text-indigo-600" />}
                <h2 className="text-lg font-semibold text-gray-800">
                  {key
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (l) => l.toUpperCase())}
                </h2>
              </div>
              <p className="text-xl font-medium text-gray-700">
                {displayValue}
              </p>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};
